import { StateCreator, create } from 'zustand';
import { DevtoolsOptions, devtools } from 'zustand/middleware';
import { DEFAULT_SORT_ORDER } from './const';

type Actions = {
  setSearchName: (searchName: string) => void;
  setSort: (sort: string[]) => void;
};

type State = {
  searchName: string;
  sort: string[];
};

type CountryState = Actions & State;

const createSlice: StateCreator<CountryState, [['zustand/devtools', never]], [], CountryState> = (set) => ({
  searchName: '',
  setSearchName: (searchName) => {
    set({ searchName }, false, 'setSearchName');
  },
  sort: DEFAULT_SORT_ORDER,
  setSort: (sort) => {
    set({ sort }, false, 'setSort');
  },
});

const devtoolsOptions: DevtoolsOptions = { name: 'CountryTable' };

export const useCountry = create<CountryState>()(devtools(createSlice, devtoolsOptions));
